import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaSync, FaFileExport, FaCalendar, FaChevronDown, FaChevronUp, FaReceipt, FaFilter } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useLoader } from '../../../../context/LoaderProvider';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        padding: "10px 0px",
        margin: '0 auto',
        fontFamily: 'Segoe UI, sans-serif'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '10px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '15px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        transition: 'all 0.3s ease'
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        marginBottom: '6px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '12px',
        marginBottom: '10px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease',
        height: '42px'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    dateInput: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: '#f8fafc',
        fontSize: '13px',
        color: '#334155',
        outline: 'none',
        height: '42px'
    },
    statusSelect: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: '#f8fafc',
        fontSize: '13px',
        color: '#334155',
        outline: 'none',
        height: '42px',
        cursor: 'pointer',
        fontWeight: '500'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        height: '42px',
        transition: 'all 0.2s ease'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        marginBottom: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderBottom: '1px solid transparent'
    },
    vendorInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    vendorName: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b'
    },
    vendorTotal: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#e66d33'
    },
    expandedContent: {
        padding: '0 24px 24px 24px',
        background: '#fafbfc',
        borderTop: '1px solid #f0f0f0'
    },
    historyTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '16px',
        fontSize: '14px'
    },
    th: {
        textAlign: 'left',
        padding: '12px 16px',
        background: '#f1f5f9',
        color: '#475569',
        fontWeight: '600',
        borderBottom: '2px solid #e2e8f0'
    },
    td: {
        padding: '12px 16px',
        borderBottom: '1px solid #e8ecf0',
        color: '#334155'
    },
    badgePaid: {
        background: '#dcfce7',
        color: '#15803d',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    badgePending: {
        background: '#fef3c7',
        color: '#b45309',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    badgeFailed: {
        background: '#fee2e2',
        color: '#b91c1c',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    viewItemsBtn: {
        background: '#e2e8f0',
        color: '#334155',
        border: 'none',
        borderRadius: '6px',
        padding: '5px 12px',
        fontSize: '12px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalContent: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        maxWidth: '650px',
        width: '100%',
        maxHeight: '85vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        borderBottom: '1px solid #edf2f7',
        paddingBottom: '12px'
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#1e293b'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#94a3b8',
        padding: '4px'
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#94a3b8'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    }
};

// ============================================
// BASE API URL
// ============================================
const API_URL = "https://backend.maamaas.com/food/api/due-payments/admin/all";

// ============================================
// COMPONENT
// ============================================
const DueOrders = () => {
    const loader = useLoader();
    const showLoader = loader?.showLoader || (() => { });
    const hideLoader = loader?.hideLoader || (() => { });

    const [vendors, setVendors] = useState([]);
    const [expandedVendor, setExpandedVendor] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [statusFilter, setStatusFilter] = useState('ALL');

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Selected order modal
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showOrderModal, setShowOrderModal] = useState(false);

    // ─── Fetch Due Payments Data with API Query Parameters ────────────────
    const fetchDuePayments = async () => {
        try {
            setLoading(true);
            setError(null);
            showLoader();

            const token = localStorage.getItem("authToken");
            if (!token) {
                throw new Error("Authentication token not found");
            }

            // Construct query parameters: ?search=...&date=...&status=...
            const params = new URLSearchParams();
            if (searchQuery && searchQuery.trim()) {
                params.append('search', searchQuery.trim());
            }
            if (selectedDate) {
                params.append('date', selectedDate);
            }
            if (statusFilter && statusFilter !== 'ALL') {
                params.append('status', statusFilter);
            }

            const queryString = params.toString();
            const url = `${API_URL}${queryString ? `?${queryString}` : ''}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch due payments: ${response.status}`);
            }

            const data = await response.json();

            // Group due payments by vendorId
            const vendorMap = new Map();

            if (Array.isArray(data)) {
                data.forEach(item => {
                    const vId = item.vendorId || 'Unknown';

                    if (!vendorMap.has(vId)) {
                        vendorMap.set(vId, {
                            id: `VEN-${String(vId).padStart(3, '0')}`,
                            vendorId: vId,
                            name: item.restaurentName,
                            totalDue: 0,
                            orders: []
                        });
                    }

                    const vendor = vendorMap.get(vId);
                    vendor.totalDue += item.dueAmount || 0;
                    vendor.orders.push({
                        ...item,
                        date: item.dueDate || (item.createdAt ? item.createdAt.split('T')[0] : ''),
                        time: item.dueTime || (item.createdAt ? new Date(item.createdAt).toLocaleTimeString() : '')
                    });
                });
            }

            const vendorList = Array.from(vendorMap.values());
            // Sort vendors by total due (highest first)
            vendorList.sort((a, b) => b.totalDue - a.totalDue);

            setVendors(vendorList);
        } catch (err) {
            console.error('❌ Error fetching due payments:', err);
            setError(err.message || 'Failed to load due payments');
            setVendors([]);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    // Initial & filter dependency effect
    useEffect(() => {
        const handler = setTimeout(() => {
            fetchDuePayments();
        }, 300); // 300ms debounce for live typing search

        return () => clearTimeout(handler);
    }, [searchQuery, selectedDate, statusFilter]);

    // ─── Calculate Stats ─────────────────────────────────────────
    const totalVendors = vendors.length;
    const totalOrders = vendors.reduce((sum, v) => sum + v.orders.length, 0);
    const totalDueAmount = vendors.reduce((sum, v) => sum + v.orders.reduce((oSum, o) => oSum + (o.dueAmount || 0), 0), 0);
    const maxDueVendor = vendors.length > 0 ? Math.max(...vendors.map(v => v.totalDue)) : 0;

    // ─── Toggle Expand ──────────────────────────────────────────
    const toggleExpand = (vendorId) => {
        setExpandedVendor(expandedVendor === vendorId ? null : vendorId);
    };

    const handleClearFilters = () => {
        setSearchQuery('');
        setSelectedDate('');
        setStatusFilter('ALL');
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const getStatusBadge = (status) => {
        const s = (status || '').toUpperCase();
        if (s === 'PAID') return styles.badgePaid;
        if (s === 'FAILED') return styles.badgeFailed;
        return styles.badgePending;
    };

    // Export CSV
    const handleExport = () => {
        if (vendors.length === 0) {
            alert('No data to export.');
            return;
        }

        try {
            const csvRows = [];
            const headers = ['Vendor ID', 'Restaurant Name', 'Order ID', 'Customer Name', 'Phone', 'Due Amount', 'Payment Method', 'Status', 'Due Date', 'Due Time', 'Items Count'];
            csvRows.push(headers.join(','));

            vendors.forEach(vendor => {
                vendor.orders.forEach(o => {
                    const row = [
                        vendor.vendorId,
                        vendor.name,
                        o.orderId,
                        `"${o.customerName || ''}"`,
                        `"${o.phoneNumber || ''}"`,
                        o.dueAmount || 0,
                        o.paymentMethod || '',
                        o.status || '',
                        o.dueDate || '',
                        `"${o.dueTime || ''}"`,
                        o.itemCount || 0
                    ];
                    csvRows.push(row.join(','));
                });
            });

            const csvString = csvRows.join('\n');
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', `due_orders_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Export error:', error);
            alert('Failed to export due orders.');
        }
    };

    const handleViewOrderDetails = (order) => {
        setSelectedOrder(order);
        setShowOrderModal(true);
    };

    return (
        <div style={styles.container}>
            {/* ─── Dashboard Stats ────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Vendors</div>
                    <div style={styles.statValue}>{totalVendors}</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Due Amount</div>
                    <div style={styles.statValue}>{formatCurrency(totalDueAmount)}</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Due Orders</div>
                    <div style={styles.statValue}>{totalOrders}</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Highest Vendor Due</div>
                    <div style={styles.statValue}>
                        {vendors.length > 0 ? formatCurrency(maxDueVendor) : '₹0.00'}
                    </div>
                </div>
            </div>

            {/* ─── Filters Bar (with API Search, Date, Status parameters) ────────────────── */}
            <div style={styles.filtersBar}>
                {/* API Search Input */}
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="Search by customer, phone, order ID..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* API Date Filter */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <input
                        type="date"
                        style={styles.dateInput}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        title="Filter by Date (YYYY-MM-DD)"
                    />
                </div>

                {/* API Status Filter Enum [PENDING, PAID, FAILED] */}
                <select
                    style={styles.statusSelect}
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="ALL">All Statuses</option>
                    <option value="PENDING">PENDING</option>
                    <option value="PAID">PAID</option>
                    <option value="FAILED">FAILED</option>
                </select>

                {/* Action Buttons */}
                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#f1f5f9',
                        color: '#475569'
                    }}
                    onClick={handleClearFilters}
                >
                    <FaSync size={14} /> Clear
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={fetchDuePayments}
                >
                    <FaSync size={14} /> Refresh
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#16a34a',
                        color: 'white'
                    }}
                    onClick={handleExport}
                >
                    <FaFileExport size={14} /> Export
                </button>
            </div>

            {/* Error state display */}
            {error && (
                <div style={{ padding: '12px 16px', backgroundColor: '#fff5f5', border: '1px solid #feb2b2', borderRadius: '8px', color: '#c53030', marginBottom: '12px' }}>
                    ⚠️ {error}
                </div>
            )}

            <div style={{ maxHeight: "60vh", overflow: "auto", scrollbarWidth: "thin" }}>
                {loading ? (
                    <div style={styles.loadingOverlay}>
                        <div className="spinner" style={{
                            width: '40px',
                            height: '40px',
                            border: '4px solid #f3f4f6',
                            borderTop: '4px solid #e66d33',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 12px'
                        }}></div>
                        <p>Loading due orders...</p>
                    </div>
                ) : vendors.length === 0 ? (
                    <div style={styles.emptyState}>
                        <p>No due orders found matching the API filters.</p>
                    </div>
                ) : (
                    vendors.map((vendor) => {
                        const vendorTotalDue = vendor.orders.reduce((sum, o) => sum + (o.dueAmount || 0), 0);
                        return (
                            <div key={vendor.id} style={styles.vendorCard}>
                                {/* Vendor Header */}
                                <div
                                    style={{
                                        ...styles.vendorHeader,
                                        borderBottom: expandedVendor === vendor.id ? '1px solid #f0f0f0' : '1px solid transparent',
                                        background: expandedVendor === vendor.id ? '#fafbfc' : 'white'
                                    }}
                                    onClick={() => toggleExpand(vendor.id)}
                                >
                                    <div style={styles.vendorInfo}>
                                        <div>
                                            <div style={styles.vendorName}>{vendor.name}</div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>
                                                {vendor.orders.length} due orders
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        <div style={{ textAlign: 'right' }}>
                                            <div style={styles.vendorTotal}>{formatCurrency(vendorTotalDue)}</div>
                                            <div style={{ fontSize: '12px', color: '#94a3b8' }}>Total Due</div>
                                        </div>
                                        {expandedVendor === vendor.id ? (
                                            <FaChevronUp color="#94a3b8" />
                                        ) : (
                                            <FaChevronDown color="#94a3b8" />
                                        )}
                                    </div>
                                </div>

                                {/* Expanded Content */}
                                {expandedVendor === vendor.id && (
                                    <div style={styles.expandedContent}>
                                        <div style={{
                                            padding: '16px 0 8px 0',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            color: '#1e293b',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <FaReceipt size={16} color="#e66d33" />
                                            Due Orders History
                                            <span style={{
                                                fontSize: '13px',
                                                fontWeight: '400',
                                                color: '#94a3b8',
                                                marginLeft: '4px'
                                            }}>
                                                ({vendor.orders.length} orders)
                                            </span>
                                        </div>
                                        <div style={{ maxHeight: "350px", overflow: "auto", scrollbarWidth: "thin" }}>
                                            {vendor.orders.length === 0 ? (
                                                <div style={styles.emptyState}>
                                                    <p>No orders available</p>
                                                </div>
                                            ) : (
                                                <table style={styles.historyTable}>
                                                    <thead>
                                                        <tr>
                                                            <th style={styles.th}>Order ID</th>
                                                            <th style={styles.th}>Customer Info</th>
                                                            <th style={styles.th}>Due Date & Time</th>
                                                            <th style={styles.th}>Payment Method</th>
                                                            <th style={styles.th}>Status</th>
                                                            <th style={styles.th}>Items Count</th>
                                                            <th style={{ ...styles.th, textAlign: 'right' }}>Due Amount</th>
                                                            <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {vendor.orders.map((entry, index) => (
                                                            <tr key={entry.id || index}>
                                                                <td style={{ ...styles.td, fontWeight: '600', color: '#e66d33' }}>
                                                                    #{entry.orderId}
                                                                </td>
                                                                <td style={styles.td}>
                                                                    <div style={{ fontWeight: '500' }}>{entry.customerName || 'N/A'}</div>
                                                                    {entry.phoneNumber && (
                                                                        <div style={{ fontSize: '11px', color: '#64748b' }}>📞 {entry.phoneNumber}</div>
                                                                    )}
                                                                </td>
                                                                <td style={styles.td}>
                                                                    <div>{formatDate(entry.date)}</div>
                                                                    {entry.dueTime && <div style={{ fontSize: '11px', color: '#64748b' }}>⏰ {entry.dueTime}</div>}
                                                                </td>
                                                                <td style={styles.td}>
                                                                    <span style={{ fontWeight: '500', color: '#1e293b' }}>
                                                                        {entry.paymentMethod || 'UPI'}
                                                                    </span>
                                                                </td>
                                                                <td style={styles.td}>
                                                                    <span style={getStatusBadge(entry.status)}>
                                                                        {entry.status || 'PENDING'}
                                                                    </span>
                                                                </td>
                                                                <td style={styles.td}>
                                                                    {entry.itemCount || (entry.orderItems ? entry.orderItems.length : 0)} items
                                                                </td>
                                                                <td style={{ ...styles.td, textAlign: 'right', fontWeight: '700', color: '#e66d33' }}>
                                                                    {formatCurrency(entry.dueAmount)}
                                                                </td>
                                                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                                                    <button
                                                                        style={styles.viewItemsBtn}
                                                                        onClick={() => handleViewOrderDetails(entry)}
                                                                    >
                                                                        View Items
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* Total Row */}
                                                        <tr style={{ background: '#f8fafc' }}>
                                                            <td colSpan="6" style={{ ...styles.td, fontWeight: '600' }}>
                                                                Total Vendor Due Amount
                                                            </td>
                                                            <td style={{ ...styles.td, textAlign: 'right', fontWeight: '700', color: '#e66d33' }}>
                                                                {formatCurrency(vendorTotalDue)}
                                                            </td>
                                                            <td style={styles.td}></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>

            {/* ─── Order Items Details Modal ─────────────────────────────── */}
            {showOrderModal && selectedOrder && (() => {
                const itemsSubtotal = (selectedOrder.orderItems || []).reduce((sum, item) => {
                    const price = parseFloat(item.totalPrice) || (parseFloat(item.price || 0) * parseInt(item.quantity || 1));
                    return sum + price;
                }, 0);
                const dueAmt = parseFloat(selectedOrder.dueAmount) || 0;
                const taxesAndCharges = dueAmt - itemsSubtotal;

                return (
                    <div style={styles.modalOverlay} onClick={() => setShowOrderModal(false)}>
                        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                            <div style={styles.modalHeader}>
                                <h3 style={styles.modalTitle}>
                                    🛒 Order #{selectedOrder.orderId} Details & Items
                                </h3>
                                <button style={styles.modalClose} onClick={() => setShowOrderModal(false)}>
                                    <MdClose />
                                </button>
                            </div>

                            <div style={{ background: '#f8fafc', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', border: '1px solid #e2e8f0', fontSize: '13px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                    <div><strong>Customer:</strong> {selectedOrder.customerName || 'N/A'}</div>
                                    <div><strong>Phone:</strong> {selectedOrder.phoneNumber || 'N/A'}</div>
                                    <div><strong>Payment Method:</strong> {selectedOrder.paymentMethod || 'UPI'}</div>
                                    <div><strong>Status:</strong> <span style={getStatusBadge(selectedOrder.status)}>{selectedOrder.status || 'PENDING'}</span></div>
                                    <div><strong>Due Date:</strong> {selectedOrder.dueDate}</div>
                                    <div><strong>Due Time:</strong> {selectedOrder.dueTime || 'N/A'}</div>
                                </div>
                            </div>

                            <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '10px', color: '#1e293b' }}>
                                Ordered Dishes & Items ({selectedOrder.orderItems ? selectedOrder.orderItems.length : 0})
                            </div>

                            {selectedOrder.orderItems && selectedOrder.orderItems.length > 0 ? (
                                <>
                                    <table style={styles.historyTable}>
                                        <thead>
                                            <tr>
                                                <th style={styles.th}>Dish Name</th>
                                                <th style={styles.th}>Category</th>
                                                <th style={styles.th}>Price</th>
                                                <th style={styles.th}>Qty</th>
                                                <th style={{ ...styles.th, textAlign: 'right' }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrder.orderItems.map((item, idx) => (
                                                <tr key={item.id || idx}>
                                                    <td style={styles.td}>
                                                        <div style={{ fontWeight: '600', color: '#1e293b' }}>{item.dishName}</div>
                                                        {item.chefType && <div style={{ fontSize: '11px', color: '#94a3b8' }}>{item.chefType}</div>}
                                                    </td>
                                                    <td style={styles.td}>
                                                        <div>{item.category || 'N/A'}</div>
                                                        {item.subCategoryName && <div style={{ fontSize: '11px', color: '#94a3b8' }}>{item.subCategoryName}</div>}
                                                    </td>
                                                    <td style={styles.td}>{formatCurrency(item.price)}</td>
                                                    <td style={styles.td}>{item.quantity}</td>
                                                    <td style={{ ...styles.td, textAlign: 'right', fontWeight: '600' }}>{formatCurrency(item.totalPrice)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Financial Breakdown (Items Subtotal, Taxes & Charges, Due Amount) */}
                                    <div style={{ marginTop: '16px', background: '#f8fafc', padding: '12px 16px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px', color: '#475569' }}>
                                            <span>Items Subtotal:</span>
                                            <span style={{ fontWeight: '600' }}>{formatCurrency(itemsSubtotal)}</span>
                                        </div>
                                        {taxesAndCharges !== 0 && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px', color: '#475569' }}>
                                                <span>Taxes & Other Charges (GST / Delivery / Fees):</span>
                                                <span style={{ fontWeight: '600', color: '#2563eb' }}>{formatCurrency(taxesAndCharges)}</span>
                                            </div>
                                        )}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid #e2e8f0', fontSize: '14px', fontWeight: '700', color: '#1e293b' }}>
                                            <span>Total Due Amount:</span>
                                            <span style={{ color: '#e66d33' }}>{formatCurrency(dueAmt)}</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div style={styles.emptyState}>
                                    <p>No item details recorded for this due order.</p>
                                </div>
                            )}

                            <button
                                onClick={() => setShowOrderModal(false)}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    background: '#e66d33',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '16px'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                );
            })()}
        </div>
    );
};

export default DueOrders;
